const updateItems = [
  {
    time: '10分钟前',
    title: '某知名演员被曝税务问题，工作室紧急发声明',
    tag: '突发事件',
    tagColor: 'bg-primary-500',
  },
  {
    time: '35分钟前',
    title: '暗网吃瓜群内流传某女星整容前素颜照，引发热议',
    tag: '热议',
    tagColor: 'bg-accent-500',
  },
  {
    time: '1小时前',
    title: '某直播平台头部公会涉嫌刷量被平台处罚',
    tag: '行业动态',
    tagColor: 'bg-secondary-500',
  },
  {
    time: '2小时前',
    title: '网友深扒某企业家少年时期黑历史，信息量惊人',
    tag: '深度挖掘',
    tagColor: 'bg-primary-500',
  },
  {
    time: '3小时前',
    title: '某综艺节目选手私下录音曝光，节目组回应称将调查',
    tag: '独家',
    tagColor: 'bg-accent-500',
  },
  {
    time: '5小时前',
    title: '多品牌连夜解约某翻车网红，合同违约金或超千万',
    tag: '后续追踪',
    tagColor: 'bg-secondary-500',
  },
  {
    time: '7小时前',
    title: '暗网吃瓜论坛新板块「金融八卦」正式上线',
    tag: '站内公告',
    tagColor: 'bg-primary-500',
  },
  {
    time: '9小时前',
    title: '某城市夜店监管风波持续，已有12人被带走调查',
    tag: '持续关注',
    tagColor: 'bg-accent-500',
  },
];

export default function Updates() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="flex items-center gap-3 mb-10">
          <div className="w-1 h-7 bg-primary-500 rounded-full"></div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-100">
            吃瓜速递
          </h2>
          <span className="text-xs text-foreground-500 mt-1">实时更新 · 8条最新动态</span>
        </div>

        <div className="max-w-3xl mx-auto relative">
          <div className="absolute left-[19px] top-0 bottom-0 w-px bg-background-300"></div>

          <div className="space-y-0">
            {updateItems.map((item, idx) => (
              <div key={idx} className="relative flex items-start gap-5 pb-6 last:pb-0">
                <div className={`relative z-10 w-[38px] h-[38px] rounded-full flex items-center justify-center flex-shrink-0 mt-0.5 ${
                  idx < 2 ? 'bg-primary-500/20' : 'bg-background-200'
                }`}>
                  <div className={`w-2.5 h-2.5 rounded-full ${
                    idx < 2 ? 'bg-primary-500' : 'bg-background-400'
                  }`}></div>
                </div>

                <div className="flex-1 min-w-0 pt-0.5">
                  <div className="flex items-center gap-2 flex-wrap mb-1">
                    <span className="text-xs text-foreground-600 whitespace-nowrap">{item.time}</span>
                    <span className={`px-2 py-0.5 text-xs text-white rounded-md whitespace-nowrap ${item.tagColor}`}>
                      {item.tag}
                    </span>
                  </div>
                  <a
                    href="#cards"
                    className="text-sm md:text-base text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {item.title}
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}